import { useState, useEffect } from 'react';
import './App.css';
import TokenStats from './components/tokenStats/tokenStats';

function App() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleWidth = () => {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleWidth);
    return () => window.removeEventListener('resize', handleWidth);
  })
  return (
    <div className="App">
      {width < 1000 ? (
        <h1>Desktop Only</h1>
      ) : (
        <TokenStats />
      )}
    </div>
  );
}

export default App;
